// Add publicly exported pages here and to the export below.  Any pages which
// are intended to only be used internally to the module should not be
// included here.

import Terminal from './TerminalPage';

export {
  Terminal,
};



// WEBPACK FOOTER //
// ./src/modules/terminal/pages/index.js